<template>
    <rkm-area
        background-color="primary"
        title="Pré-natal, parto e nascimento"
        type="box"
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-select
                    :options="data.form.puericultura.gravidezTipos"
                    label="Tipo de gravidez"
                    show-default-option
                    text-field="nome"
                    v-model="data.model.puericultura.gravidezTipoId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="data.form.puericultura.partoTipos"
                    label="Tipo de parto"
                    show-default-option
                    text-field="nome"
                    v-model="data.model.puericultura.partoTipoId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <rkm-area
                    title="Idade gestacional"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-input
                                :validations="validations.idadeGestacionalSemanas"
                                label="Semana(s)"
                                number
                                v-model="data.model.puericultura.idadeGestacionalSemanas"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-input
                                :validations="validations.idadeGestacionalDias"
                                label="Dia(s)"
                                number
                                v-model="data.model.puericultura.idadeGestacionalDias"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-area
                    title="Apgar"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="4">
                            <rkm-form-input
                                :validations="validations.apgarPrimeiroMinuto"
                                label="1º minuto"
                                number
                                v-model="data.model.puericultura.apgarPrimeiroMinuto"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-input
                                :validations="validations.apgarQuintoMinuto"
                                label="5º minuto"
                                number
                                v-model="data.model.puericultura.apgarQuintoMinuto"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-input
                                :validations="validations.apgarDecimoMinuto"
                                label="10º minuto"
                                number
                                v-model="data.model.puericultura.apgarDecimoMinuto"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <rkm-area
                    title="Antropometria ao nascer"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="4">
                            <rkm-form-input
                                :validations="validations.peso"
                                @input="handlePesoInput"
                                append="kg"
                                label="Peso"
                                placeholder="000.000"
                                v-mask="masks.peso"
                                v-model="data.model.puericultura.peso"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-input
                                :validations="validations.comprimento"
                                append="cm"
                                label="Comprimento"
                                placeholder="000"
                                v-mask="masks.comprimento"
                                v-model="data.model.puericultura.comprimento"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-input
                                :validations="validations.perimetroCefalico"
                                append="cm"
                                label="Perímetro cefálico"
                                placeholder="000.0"
                                v-mask="masks.perimetroCefalico"
                                v-model="data.model.puericultura.perimetroCefalico"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="data.additionals.paciente.isCriancaAleitamento && data.additionals.isPrimeiroAtendimentoPuericultura">
            <rkm-col cols="12">
                <rkm-form-radio-group
                    :options="data.form.puericultura.aleitamentoTipos"
                    class="mb-0 mt-1"
                    label="Tipo de aleitamento"
                    text-field="descricao"
                    v-model="data.model.puericultura.aleitamentoTipoId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
export default {
    computed: {
        validations() {
            return {
                idadeGestacionalSemanas: {
                    min_value: 20,
                    max_value: 42,
                    max: 2,
                },
                idadeGestacionalDias: {
                    min_value: 0,
                    max_value: 6,
                    max: 1,
                },
                apgarPrimeiroMinuto: {
                    min_value: 0,
                    max_value: 10,
                    max: 2,
                },
                apgarQuintoMinuto: {
                    min_value: 0,
                    max_value: 10,
                    max: 2,
                },
                apgarDecimoMinuto: {
                    min_value: 0,
                    max_value: 10,
                    max: 2,
                },
                peso: {
                    min_value: 0.5,
                    max_value: 500,
                },
                comprimento: {
                    min_value: 20,
                    max_value: 250,
                },
                perimetroCefalico: {
                    min_value: 10,
                    max_value: 200,
                },
            }
        },
    },
    data: () => ({
        masks: {
            peso: '###.###',
            comprimento: '###',
            perimetroCefalico: '###.#',
        },
    }),
    methods: {
        handlePesoInput(value) {
            const length = value.replace('.', '').length

            if (length <= 3) {
                this.masks.peso = '#.##'
            }
            else if (length <= 4) {
                this.masks.peso = '#.###'
            }
            else if (length <= 5) {
                this.masks.peso = '##.###'
            }
            else {
                this.masks.peso = '###.###'
            }
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>